var __default__ = {root:'m_17884d0f',viewport:'m_a2dae653',container:'m_fcd81474',controls:'m_39bc3463',control:'m_64f58e10',indicators:'m_71ea3ab1',indicator:'m_eae68602',slide:'m_d98df724'};
export default __default__;